const defects = {
    // "PCT_Brix": "15-13-14-15",
    // "PCT_Dirt": "0",
    // "PCT_Dust": "",
    // "PCT_Hail": "0",
    // "PCT_Mold": "0",
    // "PCT_Soft": ".42",
    // "___KP_ID": "2211210409293410898",
    // "PCT_Baxlo": "60-70-75-80-85-70-75-80-85-90",
    // "PCT_Block": "",
    // "PCT_Decay": "0",
    // "PCT_Kilos": "84",
    // "PCT_Label": "",
    // "_L_Vessel": "",
    // "PCT_Grower": "Soc. Agricola Dietz Y Parr",
    // "PCT_Splits": "0",
    // "PCT_Bruises": ".69",
    // "PCT_Crushed": "0",
    // "PCT_Package": "035 12X6 OZ USA MARITIMO",
    // "PCT_Variety": "Star",
    // "_L_CasesQTY": "35",
    // "_L_Link_Web": "http://tinyurl.com/2m5n6hja",
    // "PCT_No_Bloom": "0",
    // "PCT_Overripe": "",
    // "_L_Warehouse": "",
    // "__KF_LOTS_ID": "2211210406439402896",
    // "PCT_Sensitive": "",
    // "PCT_Undersize": "0",
    // "_L_Lot_Number": "AR20215817",
    // "PCT_Net_Weight": "185-170-185-170-180",
    // "PCT_Shriveling": "",
    // "PCT_Broken_Skin": "0",
    // "PCT_Destination": "",
    // "PCT_Open_Wounds": "0",
    // "PCT_Sample_Size": "720",
    // "PCT_Score_Final": "1",
    // "PCT_Temperature": "6.4",
    // "PCT_Underweight": "0",
    // "PCT_Wet_Berries": "0",
    // "_L_Carrier_Type": "",
    // "_L_Date_Arrival": "",
    // "_L_Name_Company": "Exportadora Alfaberries",
    // "_L_Name_Product": "Arandanos PT",
    // "_L_Name_Shipper": "Soc. Agricola Dietz Y Parr",
    // "__KF_PALLETS_ID": "2211210409283482653",
    // "PCT_Cases_Sample": "35",
    // "PCT_Frost_Damage": "0",
    // "PCT_Main_Defects": "Sin Mayores Problemas",
    // "PCT_Packing_Date": "11/19/2022",
    // "PCT_Russet_Scars": "0",
    "PCT_Size_12_13_9": "68",
    "PCT_Size_14_15_9": "32",
    // "_L_Name_Location": "Chile, Chillan",
    // "PCT_Lack_of_Color": "0",
    // "PCT_Sample_Weight": "720",
    // "_L_Date_Warehouse": "",
    // "PCT_Attached_Stems": "0",
    // "PCT_Flower_Remains": "0",
    // "PCT_Immature_Green": "0",
    // "PCT_Shrivel_Severe": ".83",
    "PCT_Size_More_16mm": "0",
    // "_L_Date_Inspection": "2022-11-19",
    // "_L_Organic_Display": "CONV",
    // "PCT_10Pieces_Weight": "19.5",
    // "PCT_Insect_Presence": "0",
    // "SYS_FinalScore_Name": "A",
    // "PCT_Shrivel_Moderate": "",
    // "PCT_Sample_Additional": "",
    // "PCT_Wounds_Not_Healed": "",
    // "PCT_Sum_of_Major_Defects": "1.94",
    // "PCT_Sum_of_Minor_Defects": "0",
    // "PCT_Sum_of_Total_Defects": "1.94",
    // "SYS_FinalScore_Color_Hex": "186BAF",
    // "_L_Name_Product_Services": "035 12X6 OZ USA MARITIMO",
    // "PCT_Sum_of_Quality_Defects": "",
    // "_L_Customer_Reference_Code": "",
    // "PCT_Sum_of_Condition_Defects": "",
    // "PCT_Baxlo_Distribution_Less60": "11.11",
    "PCT_Size_Distribution_Less12mm": "0",
    // "PCT_Baxlo_Distribution_GreaterEqual70": "77.78",
    // "PCT_Baxlo_Distribution_Between60_and64": "11.11",
    // "PCT_Baxlo_Distribution_Between65_and69": "0"
  }
  export default defects;